import * as React from 'react';
import DialogView from './DialogView';

export interface DialogProps {
  open: boolean,
  handleClose?: any,
  title: string,
  children: any,
  onLeftArrowClick?: any,
  onRightArrowClick?: any,
  fullwidth?: boolean
  footer?: any
  asModel?: boolean
  isFooter?: boolean
  onSaveClick?:any
  autoHeight?:boolean
}

const Dialog: React.FC<DialogProps> = (props: any) => {
  return <DialogView {...props} />;
}

export default Dialog;